import { mutatorAction } from 'satcheljs';
import { setItem } from 'owa-local-storage';
import getMyOutlookViewState from '../store/myOutlookViewState';
import type { MyOutlookTab, MyOutlookEntryState } from '../store/myOutlookViewState';

const SECTION_HIDDEN_KEY = 'owa-personal-os-section-hidden';

export const setMyOutlookFullPageShowingMutator: (
    isShowing: boolean,
    initialTab?: MyOutlookTab
) => void = mutatorAction(
    'setMyOutlookFullPageShowingMutator',
    (isShowing: boolean, initialTab?: MyOutlookTab): void => {
        getMyOutlookViewState().isFullPageShowing = isShowing;
        if (initialTab) {
            getMyOutlookViewState().initialTab = initialTab;
        } else if (!isShowing) {
            getMyOutlookViewState().initialTab = 'today';
        }
    }
);

export const setMyOutlookSectionHiddenMutator: (hidden: boolean) => void = mutatorAction(
    'setMyOutlookSectionHiddenMutator',
    (hidden: boolean): void => {
        getMyOutlookViewState().isSectionHidden = hidden;
        setItem(self, SECTION_HIDDEN_KEY, hidden ? 'true' : 'false');
    }
);

export const setEmulatedFolderEntryStateMutator: (state: MyOutlookEntryState | null) => void =
    mutatorAction(
        'setEmulatedFolderEntryStateMutator',
        (state: MyOutlookEntryState | null): void => {
            getMyOutlookViewState().emulatedEntryState = state;
        }
    );

export const setScheduleVisibleMutator: (visible: boolean) => void = mutatorAction(
    'setScheduleVisibleMutator',
    (visible: boolean): void => {
        getMyOutlookViewState().isScheduleVisible = visible;
    }
);

export const setHighlightedActionableItemsMutator: (ids: string[]) => void = mutatorAction(
    'setHighlightedActionableItemsMutator',
    (ids: string[]): void => {
        const current = getMyOutlookViewState().highlightedActionableItemIds;
        // Skip redundant writes so hovering non-citing sentences doesn't churn
        // the observable (and re-render the actionable rows) needlessly.
        if (current.length === ids.length && current.every((id, index) => id === ids[index])) {
            return;
        }
        getMyOutlookViewState().highlightedActionableItemIds = ids;
    }
);
